import {ToggleButtonGroup} from '@wandb/components';
import React from 'react';

import {ErrorText, SeparatedChunk} from '../../shared';

type BooleanMetricConfigProps = {
  threshold: string;
  onThresholdChange: (value: string) => void;
  hasError: boolean;
};

const BOOLEAN_ITEMS = [
  {id: '1', children: 'True'},
  {id: '0', children: 'False'},
];

export const BooleanMetricConfig = ({
  threshold,
  onThresholdChange,
  hasError,
}: BooleanMetricConfigProps) => {
  return (
    <SeparatedChunk>
      <div className="font-semibold">Expected value</div>
      <div className="mt-4">
        <ToggleButtonGroup
          aria-label="Expected boolean value"
          items={BOOLEAN_ITEMS}
          selectedKeys={threshold ? [threshold] : []}
          selectionMode="single"
          disallowEmptySelection
          size="md"
          onSelectionChange={keys =>
            onThresholdChange(String(Array.from(keys)[0]))
          }
        />
        <div className="mt-8 text-sm text-moon-600 dark:text-wb-text-secondary">
          Comparison operator is automatically set to "Equals" for boolean
          values.
        </div>
        {hasError && <ErrorText>Boolean value must be selected</ErrorText>}
      </div>
    </SeparatedChunk>
  );
};
